import {
  CartBuyerUi,
  ProductUi,
  SellerLineUi,
  TotalTicketUi,
} from '../CartUiModel';

export type ViewCartUi = {
  buyer: CartBuyerUi;
  products: ProductUi[];
  sellers: SellerLineUi[];
  total: TotalTicketUi;
};

export const initialState: ViewCartUi = {
  buyer: {
    id: '',
    name: '',
  },
  products: [],
  sellers: [],
  total: {
    total: '',
  },
};
